import { makeStyles } from '@eagleview/ev-comp-library';

export default makeStyles((theme) => ({
  button: {
    textTransform: 'none',
  },
  title: {
    height: '56px',
  },
  titleText: {
    fontSize: theme.typography.pxToRem(20),
    fontWeight: '500',
    color: theme.evPalette.charcoal[900],
    lineHeight: theme.typography.pxToRem(27),
  },
  alignContent: {
    paddingLeft: theme.spacing(3),
    paddingRight: theme.spacing(3),
  },
  ConfirmationText: {
    fontSize: theme.typography.pxToRem(14),
    fontWeight: '500',
    color: theme.evPalette.charcoal[700],
    lineHeight: theme.typography.pxToRem(18),
    paddingBottom: theme.spacing(2),
  },
  actionButtons: {
    paddingLeft: theme.spacing(3),
    paddingRight: theme.spacing(3),
    paddingBottom: theme.spacing(3),
    paddingTop: theme.spacing(1),
  },
}));
